import React from 'react';
import Events from '../../../../../components/Forms/events/index';

const mod = 'cadd';
const view = 'scoping';
const eventsView = "corrective-actions";

function CADDCorrectiveActions() {
  return <Events module={mod} view={view} eventsView={eventsView} />
};

export default CADDCorrectiveActions;
